import { SelectJobModalService, CustomToastrAction, REDIRECT, SUCCESS_REPONSE_CODE, TRANSLATION} from '@/imports-files/components/model/select-job-modal';

export class SelectJobModalAction
{
    constructor(setShowLoader, setApiError, setOptions, checkboxStep, setCheckboxStep, setFlagForRerender, router, setButtonPopup, formRef, selectJobRef)
    {
        this.selectJobModalService   =  new SelectJobModalService();
        this.setApiError = setApiError
        this.setOptions = setOptions
        this.setShowLoader = setShowLoader
        this.checkboxStep = checkboxStep
        this.setCheckboxStep = setCheckboxStep
        this.setFlagForRerender     =   setFlagForRerender;
        this.router = router
        this.customToastrAction = new CustomToastrAction()
        this.setButtonPopup = setButtonPopup
        this.formRef = formRef
        this.selectJobRef = selectJobRef
    }

    async getPreviousJobData(params)
    {
        let result = await this.selectJobModalService.getPreviousImportData(params);
        this.setApiError(result.request)
        return result.data;
    }


    dropdownJobOptions(data, t)
    {
      let listOptions = [{
                        label: t('label:active'),
                        options: [],
                      },
                      {
                        label: t('label:archived'),
                        options: [],
                     }]

      for(let element of data.active.options)
      {
        listOptions[0].options.push({label: `${element.job_title_name} (${element.system_reference})`, value: element.id})
      }
       for(let element of data.archived.options)
      {
        listOptions[1].options.push({label: `${element.job_title_name} (${element.system_reference})`, value: element.id})
      }
      return listOptions
    }   

    async getArchiveJob(event, t)
    {   
        let params = event.target.checked ? {include_archived: true} : {} 
        let data = await this.getPreviousJobData(params)
        let options = this.dropdownJobOptions(data.data, t)
         this.selectJobRef.current.select ? this.selectJobRef.current.select.clearValue() : '';
        this.setOptions(options)
        this.setFlagForRerender(Math.random() * 10000);
    }

    checkboxChange(event, formik)
    {
      let key = event.target.value
      this.checkboxStep[key] = event.target.checked;
      this.setCheckboxStep(this.checkboxStep)
     
      if(key=='stages' && !event.target.checked)
      {
        this.checkboxStep['automations'] = event.target.checked;
        this.setCheckboxStep(this.checkboxStep)
        formik.setFieldValue('automations', event.target.checked)
      }

      this.setFlagForRerender(Math.random() * 10000);
      formik.setFieldValue(key, event.target.checked)

    }

    async submitForm(values)
    {

       let steps = [];
        for(let key of Object.keys(this.checkboxStep))
        {
            if(this.checkboxStep[key])
            {
              steps.push(key);
            }
        }

      if(steps.length > 0)
      {
        this.setButtonPopup(false);
        this.setShowLoader(true)
       

        let params = {job_id: values.select_job, steps: steps}
        this.router.query.job_id ? params['current_job_id'] = this.router.query.job_id : '';
        let result = await this.selectJobModalService.importJob(params);
        this.setApiError(result.request)
        
        if(result.request.status ==  SUCCESS_REPONSE_CODE)
        {
          this.customToastrAction.setNormalToastr(result.data.success, 'success');
          let link =  REDIRECT.client.jobs.edit.replace('$job_id', result.data.id)
          this.router.push(link)
        }
        else
        {
          this.customToastrAction.setNormalToastr(this.getErrorFromHash(result.response.data.error), 'warning');
        }
        this.setShowLoader(false)
      }
      else
      {
        this.customToastrAction.setNormalToastr(TRANSLATION('errors:select_one_step'), 'warning');
      }
    }

    getErrorFromHash(hash)
    {
         if( typeof hash == 'string')
        { 
           return hash
        }
        else
        {
           return this.getErrorFromHash(hash[Object.keys(hash)[0]])
        }
    }

}